'use client'

import { Carousel } from 'react-responsive-carousel'

const testimonialContent = [
  {
    text: '“Hi Craig I just wanted to wish you every success and joy working on your new AI Incubator project 🔥♥️ I am eternally grateful and thankful for the work you have done with creating the Dojo. It’s shows something great about your character that you thrive in building incubators because you enjoy building up ambitious new start-ups wanting to influence great change. You have a very generous nature and I wanted you to know that your inspiring leadership has not gone unnoticed and I feel you are one of the greatest businessmen I have met.”',
    name: 'Laura Igwe Odii',
    work: 'CEO of Kurero',
    profile: '/testimonials/laura.webp',
  },
  {
    text: "“Working with Craig has been an honor. As an experienced entrepreneur, he's been an invaluable mentor to our team. His incubator program and Robin's team provided expert guidance for our innovative Metaverse company. Lunique.io has greatly benefited from his talent for fostering startups.”",
    name: 'Annie Siara',
    work: 'CEO of Lunique.io',
    profile: '/testimonials/annie.webp',
  },
  {
    title: 'A consummate professional',
    text: '“Patrick is a consummate professional. Passionate, but level-headed and very good at conveying a message clearly and concisely.”',
    name: 'Kurt Wuckert Jr.',
    work: 'CEO of Gorilla Pool',
    profile: '/testimonials/kurt.webp',
  },
  {
    text: '“Robin is a tech genius with expertise in AI and blockchain. He knows how to build startups cheaply and efficiently, which is a valuable skill in the fast-paced world of tech. With Robin on your team, you can be sure that your company will be at the cutting edge of technology. His knowledge and experience in these fields make him an invaluable asset to any startup looking to make a name for itself.”',
    name: 'Michal Scislowski',
    work: 'CEO of Soundoshi',
    profile: 'https://i.ibb.co/XtLd7zh/Michal.png',
  },
  {
    text: '“Craig is a firework and his ability to break down the business into smaller financial pieces was remarkable, and he helped us understand the financial implications of our business model.”',
    name: 'Ole Andre Knutli',
    work: 'CEO of Coinsurvey',
    profile: 'https://i.ibb.co/G70D1Dh/ole-Coin-1.png',
  },
  {
    text: '“Craig is an experienced and energetic founder. His previous accelerator programme was pivotal to my success; from spending a whole day with me to build my financial model and investing personally in my company. With the advent of ChatGPT I think AI is the future of companies so I wholly support Craig in setting up the accelerator programme and encouraging early-stage start ups to succeed.”',
    name: 'Hannah Nicholson',
    work: 'CEO of MoveGenius',
    profile: './testimonials/hannah.webp',
  },
  {
    text: '“Craig and Robin make an A team. Their combination of finance, business and technology is key to helping businesses to succeed. The energy, business knowledge and experience, combined with top tech skills. Unbeatable!”',
    name: 'Borja Burguillos',
    work: 'CEO of 5tars',
    profile: 'https://i.ibb.co/vdNC1zG/borja.png',
  },
  {
    text: '“The team (Robin & Craig) building this program bring a wealth of practical industry experience, combined with real strategic and technical thinking. Between the financial support we were provided, and the capability to help our in-house development to build an MVP, we were ecstatic with the support we received. Highly recommend them!”',
    name: 'Tim Malik',
    work: 'CEO of Combat IQ',
    profile: '/testimonials/tim.webp',
  },

  {
    text: '“Joining AI forge is the best thing that could have happened for my business, its truly like doing an MBA in 12 week. I’ve learned more during this time than I have in the last 10 years working in business.”',
    name: 'Antonella Cossu',
    work: 'FilmTailor',
    profile:
      '/images/testimonials/antonella-cossu.png',
  },
  {
    text: '“The thing I love about AI Forge is in comparison to other incubators is the care, the personal care that they apply to you and your business. At the end of the day it is a business, but they truly care about founders succeeding, putting time and effort out of their personal lives to ensure we succeed.”',
    name: 'George Westbrook',
    work: 'Genie-iQ',
    profile:
      '/images/testimonials/george-westbrook.jpg',
  },
  {
    text: `“The eureka moment for me in the programme was when I got deep into the financial modeling. I've always been fine at pitching, and always had a deep passion for my subject matter, but understanding how to turn it into a business only really came to light when I got through many two hour spells trying to make my model match what I envisaged in growing my business.”`,
    name: 'Richard Lewis',
    work: 'BrainMan VR',
    profile:
      '/images/testimonials/richard-lewis.jpg',
  },
]

export function Testimonial_Team() {
  return (
    <div className="bg-black py-16 sm:py-24">
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <Carousel
          showThumbs={false}
          showArrows={false}
          showStatus={false}
          autoPlay
          infiniteLoop
          transitionTime={1500}
          interval={5000}
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={50}
        >
          {testimonialContent.map((content, index) => (
            <div
              className="relative overflow-hidden bg-black py-20 px-6 shadow-xl sm:rounded-3xl sm:py-24 sm:px-10 md:px-12 lg:px-20 min-h-full"
              key={index}
            >
              <img
                className="absolute inset-0 h-full w-full object-cover"
                src="https://i.ibb.co/0JSvc3z/blusq.jpg"
                alt=""
              />
              <div className="absolute inset-0" />
              <div className="flex flex-col md:flex-row gap-8 items-center ">
                <div className="relative max-w-[90%] sm:max-w-[60%]">
                  {/* <img
                    className="h-16 w-auto object-contain"
                    src={content.logo}
                    alt=""
                  /> */}
                  <figure>
                    <blockquote className="mt-6 text-lg font-semibold text-white sm:text-xl sm:leading-8">
                      <p>{content.text}</p>
                    </blockquote>
                    <figcaption className="mt-6 text-base text-white">
                      <div className="font-semibold">{content.name}</div>
                      <div className="mt-1">{content.work}</div>
                    </figcaption>
                  </figure>
                </div>
                <div className="relative max-w-[50%] md:max-w-[30%]">
                  <img
                    className="w-100 rounded-b-full"
                    src={content.profile}
                    alt=""
                  />
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}
